import React from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../../_config/types';
import Datepicker from '../../../../components/elements/form/datepicker';
import  Button  from '../../../../components/elements/button';
import { AgGridReact } from 'ag-grid-react';


type FormValues = {
    assetName: string;
    drop: DropdownOptionType;
    assetType: string;
    purchaseDate: Date;
};


const CreateFacilities: React.FC = () => {
    const {control, register, handleSubmit, formState: { errors } } = useForm<FormValues>();
        
        const onSubmit: SubmitHandler<FormValues> = data => {
            console.log(data);
        };
        
        const columnDefs = [
            { headerName: 'Item Code', field: 'item-code', headerClass: 'bg-[#f0f0f0]'},
            { headerName: 'Item Name', field: 'item-name', headerClass: 'bg-[#f0f0f0]' },
            { headerName: 'Vendor Part Code', field: 'vendor-part-code', headerClass: 'bg-[#f0f0f0]' },
            { headerName: 'Ordered Qty', field: 'ordered-qty', headerClass: 'bg-[#f0f0f0]' },
            { headerName: 'Unit Cost', field: 'unit-cost', headerClass: 'bg-[#f0f0f0]' },
            { headerName: 'Required Qty', field: 'required-qty', headerClass: 'bg-[#f0f0f0]' },
            { headerName: 'Total Cost', field: 'total-cost', headerClass: 'bg-[#f0f0f0]' },
          ];
        
          // Define row data
          const rowData: any[] = [
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg', 'unit-cost':'$5.00', 'required-qty':'20kg', 'total-cost':'$100.00'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg', 'unit-cost':'$5.00', 'required-qty':'20kg', 'total-cost':'$100.00'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg', 'unit-cost':'$5.00', 'required-qty':'20kg', 'total-cost':'$100.00'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg', 'unit-cost':'$5.00', 'required-qty':'20kg', 'total-cost':'$100.00'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg', 'unit-cost':'$5.00', 'required-qty':'20kg', 'total-cost':'$100.00'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg', 'unit-cost':'$5.00', 'required-qty':'20kg', 'total-cost':'$100.00'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg', 'unit-cost':'$5.00', 'required-qty':'20kg', 'total-cost':'$100.00'},
            { 'item-code': 'RC 001', 'item-name': 'M8 28mm Hex Bolt', 'vendor-part-code': 'VP 001', 'ordered-qty': '50 kg', 'unit-cost':'$5.00', 'required-qty':'20kg', 'total-cost':'$100.00'},
            
          ];

    return (
         <form onSubmit={handleSubmit(onSubmit)}>
            <div className='pt-4'>
                <div className='bg-green-50 py-2 px-3'>
                    <h6 className='text-[0.813rem] font-semibold'>Receipt ID</h6>
                    <p className='text-[0.813rem] font-normal mt-2'>P 001</p>
                </div>
                <Controller
                            name='drop'
                            control={control}
                            render={({ field :{value,onChange} }) => (
                                <SelectBox 
                                label='Select PO'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='PO 001'
                                options={[]}
                                className='mb-0'
                                />
                            )}
                        />
                        <Controller
                            name='drop'
                            control={control}
                            render={({ field :{value,onChange} }) => (
                                <SelectBox 
                                label='Select Facility'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='AF Farm 1'
                                options={[]}
                                className='mb-0'
                                />
                            )}
                        />
                        <Controller
                            name='drop'
                            control={control}
                            render={({ field :{value,onChange} }) => (
                                <SelectBox 
                                label='Select Sub Facility'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Western Regional'
                                options={[]}
                                className='mb-0'
                                />
                            )}
                        />
                <div className="flex justify-between items-center">
                    <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>Line items</h4> <button className='text-primary'>Add parts</button>
                </div>
              
                <div className="ag-theme-alpine h-1/2">
                                    <AgGridReact
                                        columnDefs={columnDefs} // Pass columnDefs
                                        rowData={rowData} // Pass rowData
                                        pagination={false}
                                        domLayout="autoHeight"
                                    />
                                </div>
                <div className='flex justify-end mt-5'>
                <div className='grid grid-cols-2 gap-3'>
                    <span> Grand Total:</span>    <span className='font-normal'>$770.00</span> 
                    <span> Receipt By:</span>    <span className='font-normal'>John Doe</span>
                    <span> Receipt Date:</span>    <span className='font-normal'>12/5/24</span>                     
                </div>
                </div>
                <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Teaxtarea 
                        label='Notes'
                        value={value}
                        onChange={onChange}
                        required
                        placeholder='Write Your Notes'
                         />
                    )}
                />
               <Controller
                            name='drop'
                            control={control}
                            render={({ field :{value,onChange} }) => (
                                <SelectBox 
                                label='Attach Files'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Upload'
                                options={[]}
                                className='mb-0'
                                />
                            )}
                        />
                <hr className='border-gray-900 my-6' />
            </div>
          <div className='flex justify-end gap-2'>
                <Button working={false}>Save</Button>
                <Button theme='secondary' working={false}>Cancel</Button>
            </div>  

            <input id="assetName" {...register('assetName', { required: true })} />
                {errors.assetName && <span>This field is required</span>}

            <div>
                <label htmlFor="assetType">Asset Type</label>
                <input id="assetType" {...register('assetType', { required: true })} />
                {errors.assetType && <span>This field is required</span>}
            </div>

            <div>
                <label htmlFor="purchaseDate">Purchase Date</label>
                <input id="purchaseDate" type="date" {...register('purchaseDate', { required: true })} />
                {errors.purchaseDate && <span>This field is required</span>}
            </div>

            <button type="submit">Create Asset</button>
        </form>
    );
};

export default CreateFacilities;